/**
 * Turns Better Auth's raw English error strings into something a Vietnamese
 * user can act on.
 *
 * Two shapes arrive here for the same underlying rejection. One Tap fails
 * in-page and hands over the message verbatim ("signup disabled"); the redirect
 * flow fails server-side at the OAuth callback, where Better Auth replaces the
 * spaces with underscores and appends it as `?error=signup_disabled`. Both are
 * normalised before lookup so one table covers both.
 *
 * Anything unrecognised falls back to a generic message rather than showing the
 * user an English string from a library they have never heard of.
 */
export function googleSignInErrorMessage(raw: string): { title: string; detail: string } {
	switch (
		raw
			.trim()
			.toLowerCase()
			.replace(/[\s_]+/g, "_")
	) {
		case "signup_disabled":
			return {
				title: "Tài khoản này chưa được cấp quyền",
				detail:
					"Hệ thống không tự tạo tài khoản. Vui lòng liên hệ quản trị viên để được cấp tài khoản trước khi đăng nhập bằng Google.",
			};
		case "account_not_linked":
			return {
				title: "Email Google chưa khớp tài khoản nào",
				detail: "Vui lòng đăng nhập bằng email và mật khẩu, hoặc liên hệ quản trị viên.",
			};
		case "unable_to_create_user":
			return {
				title: "Không thể đăng nhập bằng Google",
				detail: "Vui lòng thử lại, hoặc liên hệ quản trị viên nếu lỗi tiếp diễn.",
			};
		default:
			return {
				title: "Không thể đăng nhập bằng Google",
				detail: "Vui lòng thử lại sau hoặc đăng nhập bằng email và mật khẩu.",
			};
	}
}
